export default "__VITE_ASSET__DmPkDqoo__"